
/*
 * mkb-framework
 * ============================================================================
 * Module App
 * ============================================================================
 * author: mikabo
 * http://www.mikabo.com
 * ============================================================================
 * Copyright (c) 2015, mikabo
 * All rights reserved.
 * ============================================================================
 */
define('app',['require','exports','module','jquery','underscore','app.config','app.utils','device'],function(require, exports, module) {

	'use strict';

	var $ = require('jquery');

	// Backbone dependencies.
	var _ = require('underscore');
	//var Backbone = require('backbone');
	//ar Layout = require('layoutmanager');

	// External dependencies.
	var Config = require('app.config');
	var Utils = require('app.utils');

	var Device = require('device');



	//var FastClick = require('fastclick');

	//var backboneValidation = require('backbone.validation');

	//-----------------------------------------------------------------------------------------------------
	//CONFIG APP
	//-----------------------------------------------------------------------------------------------------

	// Alias the module for easier identification.
	var app = module.exports;

	// The root path to run the application through.
	//app.root = '/';

	_.extend(app, Config);
	//_.extend(app,  window.mkb.cms);

	app.utils = Utils;

	// call disableConsole() if console is undefined or if in production
	if (!window.console || !app.debug) {
		app.utils.disableConsole(window);
	}
	/*
	//Prevent using non-existing selectors in views
	//A workaround to avoid the error is to use this.$el.find('.selector') instead of this.$('.selector').
	if (app.debugSelector) {
		var $view = Backbone.View.prototype.$;
		Backbone.View.prototype.$ = function(selector) {

			var element = $view.apply(this, arguments);
			if (element.length === 0) {
				console.error("[Backbone.View] Warning: selector '" + selector + "' do not match any element");
			}
			return element;
		};
	}
	*/
	//-----------------------------------------------------------------------------------------------------
	//CONFIG MOBILE
	//-----------------------------------------------------------------------------------------------------

	//Mobile
	app.retina = window.devicePixelRatio > 1;
	app.phone = device.mobile();
	app.tablet = device.tablet();
	app.mobile = false;
	app.appState = 'desktop';

	if (app.phone || app.tablet) {

		FastClick.attach(document.body);
		app.mobile = true;

		if (app.phone) {

			app.appState = 'phone';

		} else if (app.tablet) {

			app.appState = 'tablet';
		}

	} else {

		app.desktop = true;
	}

	/*app.mobile = false;
	app.appState = 'desktop';
	app.desktop = true;*/


	//-----------------------------------------------------------------------------------------------------
	//CONFIG BACKBONE
	//-----------------------------------------------------------------------------------------------------
	/*

	//Pubsub
	app.pubsub = _.extend({}, Backbone.Events);

	//Layoutmanager
	Backbone.Layout.configure({
		manage: true
	});


	// Since we are automatically updating the model, we want the model
	// to also hold invalid values, otherwise, we might be validating
	// something else than the user has entered in the form.
	// See: http://thedersen.com/projects/backbone-validation/#configuration/force-update
	Backbone.Validation.configure({
		forceUpdate: true,
		selector: 'label'
	});

	// Extend the callbacks to work with Bootstrap, as used in this example
	// See: http://thedersen.com/projects/backbone-validation/#configuration/callbacks
	_.extend(Backbone.Validation.callbacks, {
		valid: function(view, attr, selector) {
			var $el = view.$('[name=' + attr + ']'),
				$group = $el.closest('.form-group');

			$group.removeClass('has-error');
			$group.find('.help-block').html('').addClass('hidden');
		},
		invalid: function(view, attr, error, selector) {
			var $el = view.$('[name=' + attr + ']'),
				$group = $el.closest('.form-group');

			var er = $group.find('label').html() + error;
			$group.addClass('has-error');
			$group.find('.help-block').html(er).removeClass('hidden');
		}
	});

	*/

});